module.exports = {
  nil: Symbol('nil'),
  break: Symbol('break')
};